//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { frameTreeApi } from '@/api/public';
import Common from '@/components/develop/commonData';
import { dataDatabaseFieldsApi } from '@/api/develop';
import { getDictTreeListApi } from '@/api/form';
export default {
  components: {
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    },
    selectDepartment: function selectDepartment() {
      return import('@/components/form-common/select-department');
    },
    selectOne: function selectOne() {
      return import('@/components/form-common/select-one');
    },
    selectLabel: function selectLabel() {
      return import('@/components/form-common/select-label');
    }
  },
  props: {
    id: {
      type: String || Number,
      default: null
    },
    // 区分审批流程/触发器
    eventStr: {
      type: String,
      default: ''
    },
    // 高级筛选
    formArray: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    additionalBoolean: {
      type: String,
      default: '0'
    },
    // 最多选多少个条件
    max: {
      type: Number,
      default: null
    },
    // 不要规则设置
    noRule: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      additional_search_boolean: this.additionalBoolean,
      heightInputRole: 32,
      header: {},
      rowId: 0,
      frameTreeData: [],
      onlyOne: false,
      tableData: [],
      labelList: [],
      conditionVisible: false,
      conditionsConfig: {
        conditionNodes: []
      },
      list: Common.conditionConfig,
      conditionLen: 0,
      conditionsPopover: false,
      conditionConfig: {
        conditionList: []
      },
      newConfig: [],
      PriorityLevel: '',
      conditions: [],
      conditionRoleVisible: false,
      type: 1,
      activeIndex: -1,
      title: '',
      conditionsFields: [],
      member: ['user_id', 'update_user_id', 'owner_user_id', 'check_uid', 'card_id', 'creator', 'salesman'],
      frame: ['frame_id', 'frame'],
      date: ['date_picker', 'date_time_picker'],
      input: ['input', 'textarea', 'tag'],
      select: ['radio', 'cascader_radio', 'cascader_address', 'checkbox', 'tag', 'cascader', 'select'],
      number: ['input_number', 'input_float', 'input_percentage', 'input_price']
    };
  },
  mounted: function mounted() {
    var _this = this;
    if (!this.noRule) {
      this.getScopeFrame();
    }
    if (this.id && this.id > 0) {
      this.getList(this.id);
    }
    if (this.formArray && this.formArray.length > 0) {
      this.list.input = this.list.input.filter(function (item) {
        return item.value !== 'regex';
      });
      this.list.number = this.list.number.filter(function (item) {
        return item.value !== 'regex';
      });
      var formData = this.formArray.filter(function (item) {
        return !['file', 'image'].includes(item.type);
      });
      formData.forEach(function (item, index) {
        if (item.type == 'cascader_address') {
          _this.getCityList(index);
        }
      });
      this.conditions = formData;
    }
    if (this.eventStr === 'event' && this.$store.state.business.fieldOptions.list) {
      this.conditionConfig.conditionList = this.$store.state.business.fieldOptions.list;
    } else if (this.eventStr !== 'event' && this.$store.state.business.conditionsConfig) {
      var val = this.$store.state.business.conditionsConfig;
      this.conditionsConfig = val.value;
      this.PriorityLevel = val.priorityLevel || '';
      this.newConfig = val.priorityLevel ? this.conditionsConfig.conditionNodes[val.priorityLevel - 1] : {
        nodeUserList: [],
        conditionList: []
      };
      this.conditionConfig = val.priorityLevel ? this.conditionsConfig.conditionNodes[val.priorityLevel - 1] : {
        nodeUserList: [],
        conditionList: []
      };
      this.conditionLen = this.conditionsConfig.conditionNodes.length - 1;
    }
  },
  computed: {
    listIds: function listIds() {
      var arr = [];
      this.conditionConfig.conditionList.map(function (item) {
        arr.push(item.field);
      });
      return arr;
    },
    // 设置条件内容
    additional_search: function additional_search() {
      return this.$store.state.business.fieldOptions.list;
    },
    // 设置条件内容
    additional_Type: function additional_Type() {
      return this.$store.state.business.fieldOptions.type;
    }
  },
  watch: {
    additional_search: function additional_search(val) {
      this.conditionConfig.conditionList = val;
    },
    id: function id(val) {
      this.getList(val);
    }
  },
  methods: {
    getScopeFrame: function getScopeFrame() {
      var _this2 = this;
      var data = {
        scope: 1
      };
      frameTreeApi(data).then(function (res) {
        _this2.frameTreeData = res.data;
      });
    },
    changeValue: function changeValue(item, index) {
      if (item.category) {
        if (['in', 'not_in'].includes(item.value)) {
          this.onlyOne = false;
        } else {
          this.onlyOne = true;
        }
        this.conditionConfig.conditionList[index].option = '';
        if (item.category == 1) {
          this.conditionConfig.conditionList[index].options.depList = [];
        }
        if (item.category == 2) {
          this.conditionConfig.conditionList[index].options.userList = [];
        }
      }
      if (['is_empty', 'not_empty'].includes(item.value)) {
        this.conditionConfig.conditionList[index].option = '';
        if (item.category == 1) {
          this.conditionConfig.conditionList[index].options.depList = [];
        }
        if (item.category == 2) {
          this.conditionConfig.conditionList[index].options.userList = [];
        }
      }
    },
    // 获取条件
    getList: function getList(id) {
      var _this3 = this;
      var data = {
        approve: 1
      };
      dataDatabaseFieldsApi(id, data).then(function (res) {
        var arr1 = res.data.filter(function (item) {
          return !['file', 'image'].includes(item.type);
        });
        _this3.conditions = arr1;
        _this3.conditions.forEach(function (item, index) {
          if (item.form_value == 'cascader_address' || item.type == 'cascader_address') {
            _this3.getCityList(index);
          }
        });
      });
    },
    getCityList: function getCityList(index, item) {
      var _this4 = this;
      var obj = {
        type_id: 2
      };
      getDictTreeListApi(obj).then(function (res) {
        _this4.conditions[index].options = res.data;
      });
    },
    heightInput: function heightInput() {
      var _this5 = this;
      setTimeout(function () {
        var height = _this5.$refs.getHeight[0].clientHeight;
        _this5.heightInputRole = height === 0 ? 36 : height;
      }, 200);
    },
    // 打开一对一表格
    handleTable: function handleTable(row, index) {
      this.activeIndex = index;
      this.$refs.tableDialog.openBox(row.id);
    },
    getSelection: function getSelection(data, item) {
      item.options = [data];
      item.option = data.id;
      this.activeIndex = -1;
    },
    // 选中客户标签成功回调
    handleLabelConf: function handleLabelConf(res, item) {
      item.optionsList = res.list;
      item.option = res.ids;
    },
    addCondition: function addCondition() {
      if (this.max && this.conditionConfig.conditionList.length > this.max - 1) {
        this.$message.error('最多只能添加9个条件');
        return false;
      }
      this.conditionConfig.conditionList.push({
        field: '',
        value: '',
        type: 'input',
        form_value: 'input'
      });
    },
    close: function close() {
      var arr = JSON.parse(JSON.stringify(this.conditionConfig.conditionList));
      this.$store.commit('uadatefieldOptions', {
        list: [],
        resetList: arr,
        additional_search_boolean: ''
      });
      this.conditionConfig.conditionList = [];
      if (this.max) {
        this.$emit('saveCondition', {
          list: this.conditionConfig.conditionList,
          additional_search_boolean: this.additional_search_boolean,
          type: this.additional_Type
        });
        this.$store.commit('updateConditionDialog', false);
      }
    },
    itemConditions: function itemConditions(id, index) {
      var row = {};
      this.conditions.map(function (item) {
        if (item.field === id) {
          row = item;
        }
      });
      var data = {};
      if (this.frame.includes(row.field)) {
        // 部门
        data = {
          field: row.field,
          title: row.title,
          type: row.type,
          form_value: 'input',
          options: {
            depList: []
          },
          option: '',
          value: '',
          category: 1
        };
      } else if (this.member.includes(row.field)) {
        // 申请人
        data = {
          field: row.field,
          title: row.title,
          type: row.type,
          form_value: 'input',
          options: {
            userList: []
          },
          option: '',
          value: '',
          category: 2
        };
      } else {
        data = {
          field: row.field,
          optionsList: [],
          id: row.id,
          title: row.title,
          type: row.type,
          options: row.options,
          form_value: '',
          value: '',
          option: '',
          min: '',
          max: ''
        };
        if (data.type == 'switch') {
          data.form_value = 'switch';
        } else if (data.type == 'input_select') {
          data.form_value = 'input_select';
          this.rowId = row.id;
        } else if (this.input.includes(row.type)) {
          data.form_value = 'input';
        } else if (this.select.includes(row.type)) {
          data.form_value = 'select';
        } else if (this.date.includes(row.type)) {
          data.form_value = 'date';
        } else if (this.number.includes(row.type)) {
          data.form_value = 'number';
        }
      }
      this.$set(this.conditionConfig.conditionList, index, data);
    },
    removeItems: function removeItems(row, index) {
      var _this6 = this;
      if (this.conditions.length > 0) {
        this.conditions.forEach(function (value) {
          if (value.field === _this6.conditionConfig.conditionList[index].field) {
            value.disabled = false;
          }
        });
      }
      this.conditionsPopover = false;
      this.conditionConfig.conditionList.splice(index, 1);
    },
    // 选择成员回调
    getSelectList: function getSelectList(data, item) {
      if (data.length > 0) {
        data.forEach(function (item) {
          item.id = item.value;
        });
      }
      item.options.userList = data;
      var arr = [];
      data.map(function (item) {
        arr.push(item.id);
      });
      item.option = arr;
      this.activeIndex = -1;
    },
    // 选择部门完成回调
    changeMastart: function changeMastart(data, item) {
      item.options.depList = data;
      var arr = [];
      data.map(function (item) {
        arr.push(item.id);
      });
      item.option = arr;
      this.activeIndex = -1;
    },
    cardTag: function cardTag(index, type, itemIndex) {
      var arr = [];
      if (type == 1) {
        this.conditionConfig.conditionList[itemIndex].optionsList.splice(index, 1);
        this.conditionConfig.conditionList[itemIndex].optionsList.map(function (item) {
          arr.push(item.id);
        });
        this.conditionConfig.conditionList[itemIndex].option = arr;
      } else if (type == 2) {
        this.conditionConfig.conditionList[itemIndex].options.userList.splice(index, 1);
      } else {
        this.conditionConfig.conditionList[itemIndex].options.depList.splice(index, 1);
      }
    },
    // 保存设置
    saveCondition: function saveCondition() {
      var condition = this.conditionConfig.conditionList;
      if (condition.length > 0 && this.noRule) {
        for (var _i = 0; _i < condition.length; _i++) {
          var value = condition[_i];
          if (!value.value) {
            this.$message.error(value.title + '条件不能为空');
            return;
          }
          if (value.value == 'is_empty' || value.value == 'not_empty') {} else if (value.value == 'between') {
            if (value.max == '' || value.min == '') {
              this.$message.error(value.title + '不能为空');
              return;
            }
          } else if (['n_day', 'last_day', 'next_day'].includes(value.value)) {
            if (value.option == '' || !value.option) {
              this.$message.error(value.title + '不能为空');
              return;
            }
          } else if (['today', 'week', 'month', 'quarter'].includes(value.value)) {} else {
            if (value.category == 2 && value.options.userList.length == 0) {
              this.$message.error(value.title + '不能为空');
              return;
            } else if (value.category == 1 && value.options.depList.length == 0) {
              this.$message.error(value.title + '不能为空');
              return;
            } else if ((value.value !== 'is_empty' || value.value !== 'not_empty') && value.option == '') {
              this.$message.error(value.title + '不能为空');
              return;
            }
          }
        }
      }
      this.$store.commit('updateConditionDialog', false);
      if (this.eventStr !== 'event') {
        var a = this.conditionsConfig.conditionNodes.splice(this.PriorityLevel - 1, 1); // 截取旧下标
        this.conditionsConfig.conditionNodes.splice(this.conditionConfig.priorityLevel - 1, 0, a[0]); // 填充新下标
        this.conditionsConfig.conditionNodes.map(function (item, index) {
          item.priorityLevel = (index + 1).toString();
        });
        for (var i = 0; i < this.conditionsConfig.conditionNodes.length; i++) {
          this.conditionsConfig.conditionNodes[i].error = this.$func.conditionStr(this.conditionsConfig, i) == '请设置条件' && i != this.conditionsConfig.conditionNodes.length - 1;
        }
        this.conditionsPopover = false;
        this.$store.commit('updateConditionsConfig', {
          value: this.conditionsConfig,
          flag: true,
          id: this.$store.state.business.conditionsConfig.id
        });
      } else {
        this.$store.commit('uadatefieldOptions', {
          list: this.conditionConfig.conditionList,
          additional_search_boolean: this.additional_search_boolean,
          type: this.additional_Type
        });
        this.$emit('saveCondition', {
          list: this.conditionConfig.conditionList,
          additional_search_boolean: this.additional_search_boolean,
          type: this.additional_Type
        });
      }
    },
    closeCondition: function closeCondition() {
      this.conditionsPopover = false;
      this.conditions.forEach(function (item) {
        item.disabled = false;
      });
      this.$emit('updateConditionDialog');
      this.$store.commit('updateConditionDialog', false);
    }
  }
};